export default "__VITE_ASSET__BaP_Cko7__"